import { Component, OnInit } from '@angular/core';
import {DashboardService} from '../../../service/events/dashboard.service';


@Component({
    selector: 'app-tareas',
    standalone: false,
    templateUrl: './tareas.component.html',
    styleUrls: ['./tareas.component.scss']
})
export class TareasComponent implements OnInit {

    constructor(private dashboardEvent: DashboardService) {
    }

    ngOnInit() {
        this.dashboardEvent.setMenuItem('tareas');
    }

}
